export const getAgencyNotificationsUrl = () => 'agency/notifications';
export const getAgencyNotificationsUnreadCountUrl = () => 'agency/notifications/unread_count';
export const getAgencyNotificationsMarkAllReadUrl = () => 'agency/notifications/mark_all_read';
export const getAgencyNotificationMarkReadUrl = (id: number) => `agency/notifications/${id}`;
